import {RecipientForm} from '@/scripts/optional/recipient-form';
import { TsDOM as q} from '@/scripts/core/TsDOM'
q.safeDefineElement(RecipientForm);
